<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-grid">
        <div>
          <h3 class="footer-brand">TestHiveQA</h3>
          <p class="footer-tagline">Building the GitHub for QA professionals. Prove your skills, build your portfolio, advance your career.</p>
        </div>
        
        <div class="footer-contact">
          <p>Questions? Reach out:</p>
          <a href="mailto:contact@testhiveqa.com">contact@testhiveqa.com</a>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; 2025 TestHiveQA. All rights reserved.</p>
        <p class="footer-love">Built with ❤️ for QA professionals worldwide</p>
        <div class="footer-privacy">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
          </svg>
          Your data is safe • GDPR Compliant • We never share your information
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>